import React, { PropTypes } from 'react';
import axios from './../../../../constants/axios';
import { Table } from 'react-bootstrap';

class SaleReturnInvoiceDetailItem extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         invoiceItems: []
      };
   }

   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`saleReturns/getInventoryItemsByInvoiceId/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoiceItems: res.data
            });
         });
   }

   render() {
      const { invoiceItems } = this.state;
      return (
         <div className="SaleReturnInvoiceDetailItem" >
            <h4>Invoice Items</h4>
            <Table>
               <thead>
               <tr>
                  <th>S.L</th>
                  <th>Item Name</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>U.Total</th>
               </tr>
               </thead>
               <tbody>
               {invoiceItems && invoiceItems.map((item, index) => (
                  <tr key={item.id} >
                     <td>{index + 1}</td>
                     <td>{item.name}</td>
                     <td>{item.unit}</td>
                     <td>{item.price}</td>
                     <td>{item.unit_total}</td>
                  </tr>
               ))}
               </tbody>
            </Table>
         </div>
      );
   }
}

SaleReturnInvoiceDetailItem.propTypes = {
   params: PropTypes.object
};

export default SaleReturnInvoiceDetailItem;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/SaleReturn/SaleReturnInvoiceDetails/SaleReturnInvoiceDetailItem.js
 **/